<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
========================================================================================== -->

<template>
  <div class="activity-timeline px-5">
      <div class="vx-row activity-e-legends mb-4">
        <div class="vx-col w-full lg:w-4/12 text-base">
          {{ title }}
        </div>
        <div class="vx-col hidden lg:block text-center lg:w-2/12 text-base">
          Date / Heure
        </div>
        <div class="vx-col hidden lg:block text-center lg:w-3/12 text-base">
          Contact
        </div>
        <div class="vx-col hidden text-right lg:block lg:w-3/12 text-base">
          Action
        </div>
      </div>
      <div class="vx-row items-center activity-e-entry" v-for="(item, index) in data" :key="index">
        <div class="vx-col w-full lg:w-4/12">
          <div class="timeline-icon" :class="`bg-${item.color}`">
              <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info pl-2">
              <p class="font-semibold">{{ item.title }}</p>
              <span class="activity-desc">{{ item.desc }}</span>
              <div class="lg:hidden mb-2">
                <span class="text-gray-dark activity-e-time">{{ item.time }}</span>
                <span v-if="item.contact" class="text-gray-dark activity-e-contact"> - contact: {{ item.contact }}</span>
              </div>
          </div>
        </div>
        <div class="vx-col hidden lg:block lg:w-2/12 text-center">
          <span class="text-gray-dark activity-e-time">{{ item.time }}</span>
        </div>
        <div class="vx-col hidden lg:block lg:w-3/12 text-center">
          <span class="text-gray-dark activity-e-contact">{{ item.contact }}</span>
        </div>
        <div class="vx-col lg:w-3/12 flex justify-end">
          <vs-button disabled icon-pack="far" icon="fa-headphones-alt" color="primary" size="small" type="border">ÉCOUTER</vs-button>
        </div>
      </div>
      
  </div>
</template>

<script>
export default {
  name: 'activity-timeline',
  props: {
    title: {
      type: String,
      default: 'Suivi de l’activité'
    },
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/main/components/activityTimeline.scss";
</style>
